
import {createSlice} from "@reduxjs/toolkit";

export const usageSearchSlice = createSlice({
    name: 'usageSearchSlc',
    initialState: {value: {
                    fileId: null,
            propertyId: null,
            productName: null,
            episodeName: null,
            photoStartDateFrom: null,
            photoStartDateTo: null,
            seriesExternalId: null,
            seriesName: null,
            seasonExternalId: null,
            seasonNumberFrom: null,
            seasonNumberTo: null,
            seasonName: null,
            platformId: null,
            platformName: null,
            service: null,
            usageMarket: null,
            territory: null,
            licenseId: null,
            licensee: null,
            useStartFrom: null,
            useStartTo: null,
            useEndFrom: null,
            useEndTo: null,
            language: null,
            id: null,
            externalId: null,
            stakeholderId: null,
            status: null,
            participations: null,
            residuals: null,
            royalties: null
        }},
    reducers:

{
        changeUsageSearch: (state, action) => {
                state.value = {
                        ...state.value,  // Keep existing fields
                        ...action.payload // Merge new values
                };
        }
}
});

export const { changeUsageSearch } = usageSearchSlice.actions;

export default  usageSearchSlice.reducer ;
